import { Link } from "react-router-dom";

export default function Confidentialite() {
  return (
    <div data-testid="screen-confidentialite" style={{ maxWidth: 640 }}>
      <h1 style={{ fontSize: "1.6rem" }}>Politique de confidentialité</h1>

      <h2 style={{ fontSize: "1.1rem", marginTop: "1.2rem" }}>Données collectées</h2>
      <p>
        La seule donnée collectée est votre <strong>adresse e-mail</strong>, associée à un ou plusieurs
        <strong> codes INSEE de commune</strong> que vous choisissez de suivre. Aucune autre donnée
        personnelle n'est demandée (ni nom, ni adresse postale, ni téléphone, ni information sur votre logement).
      </p>
      <p>
        Les e-mails que vous recevez contiennent une <strong>image invisible</strong> insérée par le
        prestataire d'envoi, qui permet de <strong>comptabiliser les ouvertures</strong> du message.
        Cette mesure est configurée en <strong>mode anonyme</strong> : une ouverture ne peut pas être
        rattachée à un destinataire particulier. Elle <strong>ne peut pas être désactivée</strong> par le
        service, s'agissant d'une contrainte du prestataire. Aucune donnée d'ouverture n'est utilisée à des
        fins publicitaires ni transmise à des tiers.
      </p>
      <p>
        Dans la version <strong>HTML</strong> des e-mails, les liens passent par une <strong>adresse
        intermédiaire du prestataire d'envoi</strong>, qui <strong>comptabilise les clics</strong> avant de
        rediriger vers la destination réelle. Cette mesure est elle aussi configurée en <strong>mode
        anonyme</strong> : un clic ne peut pas être rattaché à un destinataire particulier. Elle <strong>ne
        peut pas être désactivée</strong> par le service, s'agissant d'une contrainte du prestataire. La
        version <strong>texte brut</strong> du message contient les adresses directes, sans redirection.
        Aucune donnée de clic n'est utilisée à des fins publicitaires ni transmise à des tiers.
      </p>

      <div className="pc-card" style={{ marginTop: "1rem", background: "var(--warn-soft)", borderColor: "#E4D8BE" }}>
        <h2 style={{ fontSize: "1.1rem", marginTop: 0 }}>Hébergement et transfert hors Union européenne</h2>
        <p style={{ marginBottom: 0 }}>
          Soyons clairs : l'hébergement de ce service est assuré <strong>hors de l'Union européenne</strong>.
          Vos données — votre adresse e-mail et le ou les codes INSEE de commune que vous suivez — sont donc
          <strong> stockées hors UE</strong>, en <strong>Inde</strong> (Bangalore), chez notre hébergeur
          Agione Technologies Private Limited (plateforme Emergent). Ces données restent strictement limitées
          à une adresse e-mail associée à un ou plusieurs codes de commune ; aucune autre information n'est
          transférée.
        </p>
      </div>

      <h2 style={{ fontSize: "1.1rem", marginTop: "1.2rem" }}>Finalité</h2>
      <p>
        Ces données servent <strong>uniquement</strong> à vous notifier par e-mail lorsqu'un arrêté de
        reconnaissance de l'état de catastrophe naturelle est publié pour une commune que vous suivez.
        Elles ne sont utilisées à aucune autre fin.
      </p>

      <h2 style={{ fontSize: "1.1rem", marginTop: "1.2rem" }}>Durée de conservation</h2>
      <p>Vos données sont conservées tant que votre abonnement est actif. Elles sont supprimées à votre désinscription.</p>

      <h2 style={{ fontSize: "1.1rem", marginTop: "1.2rem" }}>Sous-traitant d'envoi</h2>
      <p>
        Les e-mails sont acheminés par notre sous-traitant technique <strong>Brevo</strong>, qui traite votre
        adresse e-mail pour le seul besoin de l'envoi.
      </p>

      <h2 style={{ fontSize: "1.1rem", marginTop: "1.2rem" }}>Aucune cession, aucune publicité</h2>
      <p>Aucune donnée n'est cédée, vendue ou partagée à des tiers, ni utilisée à des fins publicitaires.</p>

      <h2 style={{ fontSize: "1.1rem", marginTop: "1.2rem" }}>Responsable de traitement et vos droits</h2>
      <p>
        Le responsable de traitement est <strong>Élodie Perrichon, entrepreneur individuel (EI)</strong>
        {" "}(pas de délégué à la protection des données). Vous disposez d'un droit d'<strong>accès</strong>,
        de <strong>rectification</strong>, d'<strong>effacement</strong> et d'<strong>opposition</strong>.
        La désinscription, accessible en un clic depuis chaque e-mail, met fin au traitement. Pour exercer
        vos droits : <a href="mailto:contact@preavis-catnat.fr">contact@preavis-catnat.fr</a>.
      </p>

      <p style={{ marginTop: "1rem", color: "var(--muted)" }}>Service gratuit et sans publicité.</p>
      <p style={{ marginTop: "1.4rem" }}><Link to="/" data-testid="confidentialite-home">Retour à l'accueil</Link></p>
    </div>
  );
}
